/**
 * @description: 会员资料报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-hzl-report">
        <div class="member-xf-list">
            <div class="row row-margin">
                <label class="list-label-4">生日查询:</label>
                <div class="col-md-3 list-time">
                    <div ref="xfBirTime">
                        <input type="text" class="form-control" placeholder="请选择日期" v-model="xfBirStartTime" /> -
                        <input type="text" class="form-control" placeholder="请选择日期" v-model="xfBirEndTime" />
                    </div>
                </div>
                <label class="list-label-4">注册门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xfShop" data-placeholder="请选择门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="xfQuery_conditions">
                        <option value="kh_id">会员卡号</option>
                        <option value="phone_numb">会员手机号</option>
                        <option value="wechat_name">微信昵称</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="xfSearch_info" :placeholder="xfEmployeeinput">
                </div>
                <label class="list-label-3">卡等级:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xf_level"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">注册时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="xfTime">
                        <input type="text" class="form-control laydate-icon" placeholder="请选择日期" v-model="xfStartTime" /> -
                        <input type="text" class="form-control laydate-icon" placeholder="请选择日期" v-model="xfEndTime" />
                    </div>
                </div>
                <label class="list-label-7">未到店消费时间:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xf_last_come" data-placeholder="请选择时间">
                        <option value="">全部</option>
                        <option value="7">7天</option>
                        <option value="15">15天</option>
                        <option value="30">30天</option>
                        <option value="60">60天</option>
                        <option value="90">90天</option>
                        <option value="365">365天</option>
                    </select>
                </div>
                <label class="list-label-3">介绍人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xf_intro"></select>
                </div>
                <label class="list-label-4">来源门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="sourceShop" data-placeholder="请选择门店"></select>
                </div>
            </div>
            <div class="row row-margin">
                <div class="col-md-5 range-txt">
                    <div class="item">
                        <span>通用余额大于</span>
                        <el-input size="small" v-model="account_min">
                            <template slot="append">元</template>
                        </el-input>
                    </div>
                    <div class="item">
                        <span>通用余额小于</span>
                        <el-input size="small" v-model="account_max">
                            <template slot="append">元</template>
                        </el-input>
                    </div>
                </div>
                <div class="pull-right">
                    <a href="https://vodonline.oss-cn-beijing.aliyuncs.com/uploads/importxls/巨嗨科技会员导入模板.xls" class="btn btn-flat btn-middle btn-orange">会员资料模板下载</a>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="xfXlsFun">会员资料模板导入</button>
                    <input type="file" @change="uploadXfXls($event)" id="xfXlsFile" ref="xfXlsFile">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="openXfHistory">群发历史任务</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="xfSendMsgs">短信群发</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getXfExportSet">导出</button>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getXfList(1)">查询</button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column label="行号" width="50">
                    <template slot-scope="scope">{{scope.$index + 1}}</template>
                </el-table-column>
                <el-table-column prop="activation_time" label="注册时间" width="110"></el-table-column>
                <el-table-column prop="shop_name" label="注册门店" width="110"></el-table-column>
                <el-table-column prop="username" label="会员姓名"></el-table-column>
                <el-table-column prop="nickname" label="微信昵称"></el-table-column>
                <el-table-column prop="level_name" label="卡等级"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号" width="150"></el-table-column>
                <el-table-column prop="mobile" label="会员手机号" width="120"></el-table-column>
                <el-table-column prop="birthday" label="生日" width="100"></el-table-column>
                <el-table-column label="会员卡余额">
                    <el-table-column prop="account" label="通用账户"></el-table-column>
                    <el-table-column prop="present_account" label="赠送账户"></el-table-column>
                    <el-table-column prop="room_account" label="房费账户"></el-table-column>
                    <el-table-column prop="total_account" label="合计"></el-table-column>
                </el-table-column>
                <el-table-column label="会员卡充值">
                    <el-table-column prop="recharge_pay_amount" label="充值金额"></el-table-column>
                    <el-table-column prop="recharge_present_amount" label="赠送金额"></el-table-column>
                    <el-table-column prop="recharge_total_amount" label="合计"></el-table-column>
                </el-table-column>
                <el-table-column prop="pay_total_amount" label="会员卡消费总额"></el-table-column>
                <el-table-column label="会员卡积分">
                    <el-table-column prop="all_points" label="累计积分"></el-table-column>
                    <el-table-column prop="consumption_points" label="已用积分"></el-table-column>
                    <el-table-column prop="points" label="剩余积分"></el-table-column>
                </el-table-column>
                <el-table-column prop="come_shop_num" label="到店次数"></el-table-column>
                <el-table-column prop="consumption" label="累计消费" width="110">
                    <template #header>
                        <div>
                            累计消费
                            <el-popover
                                placement="top"
                                trigger="hover"
                                title="累计说明："
                                content="不仅仅是使用会员卡支付的金额，包含使用会员卡后用其他支付方式支付的金额"
                            >
                                <i class="el-icon-question custom-icon" slot="reference"></i>
                            </el-popover>
                        </div>
                    </template>
                    <template #default="{row}">
                        <span>{{row.consumption}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="introducer_name" label="介绍人"></el-table-column>
                <el-table-column prop="source_shop_name" label="来源门店" width="110"></el-table-column>
                <el-table-column label="操作" width="120" fixed="right">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="onDelClick(scope.row.vip_card)" v-if="hasDelAuth">删除</span>
                        <span class="text-blue" @click="onCouponDetailClick(scope.row)">卡券详情</span>
                        <span class="text-blue" @click="getXfDetail(scope.row.id)">更多</span>
                        <span class="text-blue" @click="setPageParams(scope.row)">冲销详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getXfList">
            </el-pagination>
            <div class="check-sum" @click="doSum">查看合计金额</div>

            <!-- 合计弹窗 -->
            <div class="sum-pop ele-hide" ref="sum_pop">
                <el-table
                    v-loading="pop_loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    style="width:100%"
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    :data="sum_table"
                    :key="sumTableKey">
                    <el-table-column label="会员卡余额">
                        <el-table-column prop="account" label="通用账户" width="150"></el-table-column>
                        <el-table-column prop="present_account" label="赠送账户" width="150"></el-table-column>
                        <el-table-column prop="room_account" label="房费账户" width="150"></el-table-column>
                        <el-table-column prop="account_total" label="合计" width="150"></el-table-column>
                    </el-table-column>
                    <el-table-column label="会员卡充值">
                        <el-table-column prop="recharge_pay_amount" label="充值金额" width="150"></el-table-column>
                        <el-table-column prop="recharge_present_amount" label="赠送金额" width="150"></el-table-column>
                        <el-table-column prop="recharge_total_amount" label="合计" width="150"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="pay_total_amount" label="会员卡消费总额" width="150"></el-table-column>
                    <el-table-column label="会员卡积分">
                        <el-table-column prop="points_total" label="累计积分" width="150"></el-table-column>
                        <el-table-column prop="consumption_points" label="已用积分" width="150"></el-table-column>
                        <el-table-column prop="points" label="剩余积分" width="150"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="come_shop_num" label="到店次数" width="150"></el-table-column>
                    <el-table-column prop="consumption" label="累计消费" width="150"></el-table-column>
                </el-table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="xfExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xfExport_allcheck' @click='xfExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="activation_time">
                            <label>注册时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="shop_name">
                            <label>注册门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="username">
                            <label>会员姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="nickname">
                            <label>微信昵称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="level_name">
                            <label>卡等级</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="mobile">
                            <label>会员手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="birthday">
                            <label>生日</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="account">
                            <label>通用账户</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="room_account">
                            <label>房费账户</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="present_account">
                            <label>赠送账户</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="total_account">
                            <label>会员卡余额合计</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="recharge_pay_amount">
                            <label>充值金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="recharge_present_amount">
                            <label>赠送金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="recharge_total_amount">
                            <label>会员卡充值合计</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="pay_total_amount">
                            <label>会员卡消费总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="all_points">
                            <label>累积积分</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="consumption_points">
                            <label>已用积分</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="points">
                            <label>剩余积分</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="come_shop_num">
                            <label>到店次数</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="consumption">
                            <label>累计消费</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="introducer_name">
                            <label>介绍人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xfExport_checkModel' value="source_shop_name">
                            <label>来源门店</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='xfExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='xfExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 详情 -->
        <div class="member-xf-detail">
            <div class="page-tit">会员资料详情</div>
            <div class="member-xf-dcon">
                <div class="col-md-5">
                    <label class="col-md-3">会员姓名：</label>
                    <span class="col-md-9">{{xfDetail.username}}</span>
                    <label class="col-md-3">微信昵称：</label>
                    <span class="col-md-9">{{xfDetail.nickname}}</span>
                    <label class="col-md-3">会员卡手机号：</label>
                    <span class="col-md-9">{{xfDetail.mobile}}</span>
                    <label class="col-md-3">会员卡名称：</label>
                    <span class="col-md-9">{{xfDetail.level_name}}</span>
                    <label class="col-md-3">注册门店：</label>
                    <span class="col-md-9">{{xfDetail.shop_name}}</span>
                    <label class="col-md-3">生日：</label>
                    <span class="col-md-9">{{xfDetail.birthday}}</span>
                    <label class="col-md-3">适用门店：</label>
                    <span class="col-md-9">{{xfDetail.satisfy_shop_name}}</span>
                    <label class="col-md-3">注册方式：</label>
                    <span class="col-md-9">{{xfDetail.add_from_name}}</span>
                </div>
                <div class="col-md-5">
                    <label class="col-md-3">会员折率：</label>
                    <span class="col-md-9">{{xfDetail.discount_rate}}%（{{xfDetail.discount_rate / 10}}折）</span>
                    <label class="col-md-3">通用账户：</label>
                    <span class="col-md-9">¥{{xfDetail.account}}</span>
                    <label class="col-md-3">积分：</label>
                    <span class="col-md-9">{{xfDetail.points}}分</span>
                    <label class="col-md-3">状态：</label>
                    <span class="col-md-9">{{xfDetail.status_name}}</span>
                    <label class="col-md-3">会员注册费用：</label>
                    <span class="col-md-9">{{xfDetail.registration_fee}}</span>
                    <label class="col-md-3">注册时间：</label>
                    <span class="col-md-9">{{xfDetail.activation_time}}</span>
                </div>
            </div>
            <div class="member-xf-ranking">
                <ul class="member-xf-rk-tit clearfix">
                    <li class="member-xf-tit-sel" @click="navSel(0)">商品消费排行前20</li>
                    <li @click="navSel(1)">歌曲点唱排行前20</li>
                </ul>
                <div class="member-xf-rk-con">
                    <div class="member-xf-con-sel">
                        <h3>商品消费排行前20</h3>
                        <ul>
                            <li class="clearfix" v-for="item in xfGoodsInfo">
                                <em class="col-md-2">{{item.goods_name}}</em>
                                <p :style="{width: item.count / divisorNum * 100 +'%'}">{{item.count}}</p>
                            </li>
                        </ul>
                        <p>没有商品消费记录</p>
                    </div>
                    <div>
                        <h3>歌曲点唱排行前20</h3>
                        <ul>
                            <li class="clearfix" v-for="item in xfSongsInfo">
                                <em class="col-md-2">{{item.title}}</em>
                                <p :style="{width: item.count / diviSongNum * 100 +'%'}">{{item.count}}</p>
                            </li>
                        </ul>
                        <p>没有歌曲点唱记录</p>
                    </div>
                </div>
            </div>
            <div class="member-xf-dbtn col-md-2">
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="backList">返回</button>
            </div>
        </div>
        <!-- 新增、修改群发短信 -->
        <div class="xf-msg-edit" ref="xf_msg_edit">
            <div class="xf-msg-tit">当前门店钱包余额为<em>{{xf_shop_amount}}</em>元，单条短信收费为<em>{{xf_msg_amount}}</em>元/条</div>
            <div class="row">
                <label class="col-md-3">发送对象：</label>
                <div class="col-md-9">
                    <div class="xf-msg-obj">
                        <textarea v-model="xf_msg_phones" readonly></textarea>
                        <p>当前对象<em>{{list_total}}</em>人</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="col-md-3">发送内容：</label>
                <div class="col-md-9">
                    <div class="xf-msg-con">
                        <p ref="xf_msg_con">请选择消息模板</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="col-md-3">设定发送时间：</label>
                <div class="xf-msg-time">
                    <div class="col-md-4">
                        <div ref="xf_set_time">
                            <input type="text" class="form-control" v-model="xf_sel_date" placeholder="请选择日期">
                        </div>
                    </div>
                    <div class="col-md-5 pull-right">
                        <button type="button" class="btn btn-flat btn-middle btn-orange pull-right" @click="openMsgTemps">选择消息模板</button>
                    </div>
                    <p class="col-md-9 pull-right">注：发送时间只能设置为早上8点-10点</p>
                </div>
            </div>
        </div>
        <!-- 短信模板 -->
        <div class="xf-msg-template" ref="xf_msg_template">
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="xf_msg_temps"></table>
            </div>
        </div>
        <!-- 会员短信群发历史记录 -->
        <div class="member-xf-history">
            <div class="page-tit">
                会员短信群发历史记录
                <button type="button" class="btn btn-flat btn-middle btn-orange pull-right" @click="backList">返回</button>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="xf_history_list"></table>
            </div>
        </div>
        <!-- 短信发送对象 -->
        <div class="xf-send-obj" ref="xf_send_obj">
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="xf_send_list"></table>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                xfEmployeeinput: '请输入会员卡号',
                xfSearch_field: "kh_id",
                xfSearch_info: "",
                xfBirStartTime: '',
                xfBirEndTime: '',
                xfStartTime: '',
                xfEndTime: '',
                account_min: '', // 通用余额大于
                account_max: '', // 通用余额小于
                xfDetail: {
                    type: Object
                },
                xfGoodsInfo: {
                    type: Object
                },
                divisorNum: "",
                xfSongsInfo: {
                    type: Object
                },
                diviSongNum: "",
                xfExport_allcheck: false,
                c_xfExport_allcheck: false,
                xfExport_checkModel: [],
                xfExport_checkData: ['activation_time', 'shop_name', 'username', 'nickname', 'level_name', 'vip_card', 'mobile', 'birthday', 'account', 'room_account', 'present_account', 'total_account', 'recharge_pay_amount', 'recharge_present_amount', 'recharge_total_amount', 'pay_total_amount', 'come_shop_num', 'consumption', 'all_points', 'consumption_points', 'points', 'introducer_name', 'source_shop_name'],
                xfExport_type: 1,
                loading: false,
                list_total: 0,
                list_page: 1,
                list_table: [],
                sum_table: [],
                pop_loading: false,
                sumTableKey: Math.random(),
                isSuming: false,
                book_export_log_list: [], // 预约导出记录
                hasDelAuth: false, // 有删除会员资料权限
                xf_shop_amount: '',
                xf_msg_amount: '',
                xf_msg_phones: '',
                xf_sel_date: '',
                xf_temp_id: '',
                xf_temp_params: [],
                xf_history_count: '',
                xf_send_count: '',
                mr_hcx_menu: {},
                or_kq_menu: {},
            }
        },
        computed: {
            menunew() {
                return JSON.parse(this.$store.state.menunew)
            }
        },
        watch: {
            xfExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.xfExport_checkModel.length >= this.xfExport_checkData.length) {
                        this.xfExport_allcheck = true;
                        this.c_xfExport_allcheck = true;
                    } else {
                        this.xfExport_allcheck = false;
                        this.c_xfExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            _this.initXfBirthday();
            _this.getVipLevel();
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            _this.getPageMenu()
            // 下拉选项
            $(_this.$refs.xfQuery_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1
            }).change(function() {
                _this.xfSearch_field = $(this).val();
                if(_this.xfSearch_field == 'kh_id') {
                    _this.xfEmployeeinput = '请输入会员卡号';
                } else if(_this.xfSearch_field == 'phone_numb') {
                    _this.xfEmployeeinput = '请输入会员手机号';
                } else if(_this.xfSearch_field == 'wechat_name') {
                    _this.xfEmployeeinput = '请输入微信昵称';
                }
            });
            $(_this.$refs.xf_last_come).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                allowClear: true,
                width: '100%'
            });
        },
        methods: {
            // 生日
            initXfBirthday: function() {
                let _this = this;
                _this.xfBirStartTime = '';
                _this.xfBirEndTime = '';
                _this.xfStartTime = '';
                _this.xfEndTime = '';
                $(_this.$refs.xfBirTime).daterangepicker({
                    showDropdowns: true,
                    showSelectYear: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
					dateLimit : {
                        days : 30
                    }
                }, function(start, end, label) {
                    _this.xfBirStartTime = start.format('MM-DD');
                    _this.xfBirEndTime = end.format('MM-DD');
                });

                $(_this.$refs.xfTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: _this.IntstartTime,
                    endDate: _this.IntendTime,
                }, function(start, end, label) {
                    _this.xfStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.xfEndTime = end.format('YYYY-MM-DD HH:mm');
                });

                // 短信发送时间
                $(_this.$refs.xf_set_time).daterangepicker({
                    singleDatePicker: true,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    minDate: new Date()
                }, function(start, end, label) {
                    _this.xf_sel_date = start.format('YYYY-MM-DD')
                });
            },
            // 卡等级
            getVipLevel() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Vip/getVipLevelCombo",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: "0", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xf_level).html("");
                            $(_this.$refs.xf_level).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.xfShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.getStaff(e.params.data.id);
                            });
                            $(_this.$refs.xfShop).val(data.response.result[1].id).trigger('change');
                            _this.getStaff($(_this.$refs.xfShop).val());
                            //来源门店
                            $(_this.$refs.sourceShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                            $(_this.$refs.sourceShop).val(data.response.result[0].id).trigger('change');
                            _this.getXfList(1)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 介绍人
            getStaff(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "user/getSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: "0", text: "全部" }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xf_intro).html("");
                            $(_this.$refs.xf_intro).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 跳转菜单
            getPageMenu: function() {
                this.menunew.forEach(i => {
                    if(i.id == '544') {// 报表
                        i.submenu.forEach(j => {
                            if(j.id == '567') { // 会员报表
                                j.submenu.forEach(k => {
                                    if(k.id == '813') {
                                        // 会员冲销报表
                                        this.mr_hcx_menu = k
                                    }
                                    if (k.id == '617') { // 会员资料报表
                                        this.hasDelAuth = false
                                        k.submenu.forEach(x => {
                                            if (x.id == '1323') {
                                                this.hasDelAuth = true
                                            }
                                        })
                                    }
                                })
                            }
                            if (j.id == '879') { // 其他报表
                                j.submenu.forEach(k => {
                                    if(k.id == '913') {
                                        // 卡券报表
                                        this.or_kq_menu = k
                                    }
                                })
                            }
                        })
                    }
                })
            },
            // 跳转参数
            setPageParams(row) {
                if(!!this.mr_hcx_menu.id) {
                    const obj = {
                        name: 'mr_hcx_report',
                        params: {
                            vip_card: row.vip_card
                        }
                    }
                    this.$emit("pageLink", this.mr_hcx_menu, obj)
                }else {
                    layer.msg("无冲销报表查看权限")
                }
            },

            
            // 获取会员资料报表列表
            getXfList: function(page) {
                let _this = this,
                    shop_id = $(_this.$refs.xfShop).val(),
                    source_shop_id = $(_this.$refs.sourceShop).val();
                let vip_card = '',
                    mobile = '',
                    nickname = '';
                if(_this.xfSearch_field == 'kh_id') {
                    vip_card = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'phone_numb') {
                    mobile = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'wechat_name') {
                    nickname = _this.xfSearch_info;
                }
                _this.loading = true
                _this.list_page = page
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "birthday_start_time": _this.xfBirStartTime,
                            "birthday_end_time": _this.xfBirEndTime,
                            "start_time": _this.xfStartTime,
                            "end_time": _this.xfEndTime,
                            "shop_id": shop_id,
                            "vip_card": vip_card,
                            "mobile": mobile,
                            "nickname": nickname,
                            "last_come_time": $(_this.$refs.xf_last_come).val() || '',
                            "level_id": $(_this.$refs.xf_level).val(),
                            "introducer_id": $(_this.$refs.xf_intro).val() || '',
                            "source_shop_id": source_shop_id,
                            "account_min": _this.account_min == '' ? undefined : _this.account_min,
                            "account_max": _this.account_max == '' ? undefined : _this.account_max
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getVipHabitsList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(page == '1') {
                                _this.list_total = Number(data.response.result.total);
                                let arr = [];
                                $.each(data.response.result.rows, function(k, v) {
                                    if(v.mobile != '' && arr.length < 8) {
                                        arr.push(v.mobile);
                                    }
                                });
                                _this.xf_msg_phones = arr.join() + '...';
                            }
                            _this.list_table = data.response.result.rows;
                            _this.loading = false;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            _this.loading = false;
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 查看合计金额
            doSum() {
                if(this.isSuming) {
                    return;
                }
                this.isSuming = true;

                let _this = this,
                    shop_id = $(_this.$refs.xfShop).val(),
                    source_shop_id = $(_this.$refs.sourceShop).val();
                let vip_card = '',
                    mobile = '',
                    nickname = '';
                if(_this.xfSearch_field == 'kh_id') {
                    vip_card = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'phone_numb') {
                    mobile = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'wechat_name') {
                    nickname = _this.xfSearch_info;
                }
                _this.pop_loading = true;

                Vue.axios.post('FinanceReport/getVipAccountSum', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "birthday_start_time": _this.xfBirStartTime,
                            "birthday_end_time": _this.xfBirEndTime,
                            "start_time": _this.xfStartTime,
                            "end_time": _this.xfEndTime,
                            "shop_id": shop_id,
                            "vip_card": vip_card,
                            "mobile": mobile,
                            "nickname": nickname,
                            "last_come_time": $(_this.$refs.xf_last_come).val() || '',
                            "level_id": $(_this.$refs.xf_level).val(),
                            "introducer_id": $(_this.$refs.xf_intro).val() || '',
                            "source_shop_id": source_shop_id,
                            "account_min": _this.account_min == '' ? undefined : _this.account_min,
                            "account_max": _this.account_max == '' ? undefined : _this.account_max
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.sum_table = []
                        _this.sum_table.push(res.data.response.result);
                        _this.sumTableKey = Math.random();

                        layer.confirm('', {
                            skin: 'public-alert-skin',
                            type: 1,
                            btn: [], // 按钮
                            title: ['合计', true],
                            area: ['1000px', ''], // 宽高
                            content: $(_this.$refs.sum_pop),
                            offset: '260px',
                        });
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                    _this.pop_loading = false;
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
                .finally(() => {
                    this.isSuming = false;
                });
            },

            // 点击查看“卡券详情”
            onCouponDetailClick(row) {
                if (!!this.or_kq_menu.id) {
                    const obj = {
                        name: 'or_kq_report',
                        params: {
                            vip_card: row.vip_card
                        }
                    }
                    this.$emit("pageLink", this.or_kq_menu, obj)
                }else {
                    layer.msg("无卡券报表查看权限")
                }
            },

            // 点击“删除”
            onDelClick(vip_card) {
                let _this = this 

                layer.confirm('删除后数据将不可恢复！确认删除？', {
                    btn: ['确定', '取消'],
                    title: '提示',
                }, function() {
                    Vue.axios.post('Vip/delVip', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "vip_card": vip_card
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        layer.closeAll()
                        if(res.data.response.result_code == "true") {
                            layer.msg('操作成功');
                            _this.getXfList(_this.list_page)
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                });
            },

            // 获取导出设置
            getXfExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/vipHabitsExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.xfExport_checkModel = data.response.result.export_fields;
                                _this.xfExport_type = data.response.result.export_type;
                            } else {
                                _this.xfExport_checkModel = _this.xfExport_checkData;
                                _this.xfExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.xfExport_alert)
                }, function() {
                    _this.checkExport();

                });
            },
            // 导出字段全选
            xfExportCheckedAll: function() {
                let _this = this;
                _this.xfExport_allcheck = _this.c_xfExport_allcheck;
                if(!_this.xfExport_allcheck) { // 实现全选
                    _this.xfExport_checkModel = [];
                    _this.xfExport_checkData.forEach(function(item) {
                        _this.xfExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.xfExport_checkModel = [];
                }
            },
            // 点击“导出”
            exportXfList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.xfShop).val(),
                    source_shop_id = $(_this.$refs.sourceShop).val();
                let export_fields = JSON.stringify(_this.xfExport_checkModel);
                let vip_card = '',
                    mobile = '',
                    nickname = '';
                if(_this.xfSearch_field == 'kh_id') {
                    vip_card = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'phone_numb') {
                    mobile = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'wechat_name') {
                    nickname = _this.xfSearch_info;
                }
                let last_come_time = $(_this.$refs.xf_last_come).val() || '';
                let introducer_id = $(_this.$refs.xf_intro).val() || '';
                let account_min = _this.account_min == '' ? '' : "&account_min=" + _this.account_min
                let account_max = _this.account_max == '' ? '' : "&account_max=" + _this.account_max
                window.location.href = Vue.ctUrl + "FinanceReport/vipHabitsExport?" +
                    "birthday_start_time=" + _this.xfBirStartTime +
                    "&birthday_end_time=" + _this.xfBirEndTime +
                    "&start_time=" + _this.xfStartTime +
                    "&end_time=" + _this.xfEndTime +
                    "&shop_id=" + shop_id +
                    "&vip_card=" + vip_card +
                    "&mobile=" + mobile +
                    "&nickname=" + nickname +
                    "&last_come_time=" + last_come_time +
                    "&level_id=" + $(_this.$refs.xf_level).val() +
                    "&introducer_id=" + introducer_id +
                    "&source_shop_id=" + source_shop_id +
                    account_min +
                    account_max +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.xfExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },

            // 检查导出状态
            checkExport() {
                let _this = this,
                    shop_id = $(_this.$refs.xfShop).val(),
                    source_shop_id = $(_this.$refs.sourceShop).val();
                let vip_card = '',
                    mobile = '',
                    nickname = '';
                if(_this.xfSearch_field == 'kh_id') {
                    vip_card = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'phone_numb') {
                    mobile = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'wechat_name') {
                    nickname = _this.xfSearch_info;
                }

                Vue.axios.post('FinanceReport/vipHabitsExportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "birthday_start_time": _this.xfBirStartTime,
                            "birthday_end_time": _this.xfBirEndTime,
                            "start_time": _this.xfStartTime,
                            "end_time": _this.xfEndTime,
                            "shop_id": shop_id,
                            "vip_card": vip_card,
                            "mobile": mobile,
                            "nickname": nickname,
                            "last_come_time": $(_this.$refs.xf_last_come).val() || '',
                            "level_id": $(_this.$refs.xf_level).val(),
                            "introducer_id": $(_this.$refs.xf_intro).val() || '',
                            "source_shop_id": source_shop_id,
                            "account_min": _this.account_min == '' ? undefined : _this.account_min,
                            "account_max": _this.account_max == '' ? undefined : _this.account_max
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.exportXfList();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this,
                    shop_id = $(_this.$refs.xfShop).val(),
                    source_shop_id = $(_this.$refs.sourceShop).val();
                let export_fields = JSON.stringify(_this.xfExport_checkModel);
                let vip_card = '',
                    mobile = '',
                    nickname = '';
                if(_this.xfSearch_field == 'kh_id') {
                    vip_card = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'phone_numb') {
                    mobile = _this.xfSearch_info;
                } else if(_this.xfSearch_field == 'wechat_name') {
                    nickname = _this.xfSearch_info;
                }

                Vue.axios.post('FinanceReport/vipHabitsExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "birthday_start_time": _this.xfBirStartTime,
                            "birthday_end_time": _this.xfBirEndTime,
                            "start_time": _this.xfStartTime,
                            "end_time": _this.xfEndTime,
                            "shop_id": shop_id,
                            "vip_card": vip_card,
                            "mobile": mobile,
                            "nickname": nickname,
                            "last_come_time": $(_this.$refs.xf_last_come).val() || '',
                            "level_id": $(_this.$refs.xf_level).val(),
                            "introducer_id": $(_this.$refs.xf_intro).val() || '',
                            "source_shop_id": source_shop_id,
                            "account_min": _this.account_min == '' ? undefined : _this.account_min,
                            "account_max": _this.account_max == '' ? undefined : _this.account_max,
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            // 会员资料报表详情
            getXfDetail: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getVipHabitsDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        _this.xfDetail = data.response.result;
                        $('.member-xf-list').hide();
                        $('.member-xf-detail').show();
                        if(_this.xfDetail.goods_info.length == 0 && _this.xfDetail.songs_info.length == 0) {
                            $('.member-xf-ranking').hide();
                            return;
                        }
                        $('.member-xf-ranking').show();
                        if(_this.xfDetail.goods_info.length != 0) {
                            _this.xfGoodsInfo = data.response.result.goods_info;
                            _this.divisorNum = (_this.xfGoodsInfo[0].count / 0.73).toFixed(2);
                            $('.member-xf-rk-con div ul').eq(0).show();
                            $('.member-xf-rk-con div>p').eq(0).hide();
                        } else {
                            _this.xfGoodsInfo = {
                                type: Object
                            };
                            _this.divisorNum = "";
                            $('.member-xf-rk-con div>p').eq(0).show();
                            $('.member-xf-rk-con div ul').eq(0).hide();
                        }
                        if(_this.xfDetail.songs_info.length != 0) {
                            _this.xfSongsInfo = data.response.result.songs_info;
                            _this.diviSongNum = (_this.xfSongsInfo[0].count / 0.73).toFixed(2);
                            $('.member-xf-rk-con div ul').eq(1).show();
                            $('.member-xf-rk-con div>p').eq(1).hide();
                        } else {
                            _this.xfSongsInfo = {
                                type: Object
                            };
                            _this.diviSongNum = "";
                            $('.member-xf-rk-con div>p').eq(1).show();
                            $('.member-xf-rk-con div ul').eq(1).hide();
                        }
                    },
                    error: function(err) {
                        Vue.timeoutfun(data.response.result_status,_this);
                        layer.msg(data.response.error_msg);
                    }
                });
            },
            // tab
            navSel: function(num) {
                $('.member-xf-rk-tit li').removeClass('member-xf-tit-sel');
                $('.member-xf-rk-tit li').eq(num).addClass('member-xf-tit-sel');
                $('.member-xf-rk-con div').removeClass('member-xf-con-sel');
                $('.member-xf-rk-con div').eq(num).addClass('member-xf-con-sel');
            },
            // 返回列表
            backList: function() {
                $('.member-xf-detail').hide();
                $('.member-xf-history').hide();
                $('.member-xf-list').show();
            },
            // 导入xls文件
            xfXlsFun: function() {
                this.$refs.xfXlsFile.click();
            },
            // 导入
            uploadXfXls: function(e) {
                let _this = this;

                let formData = new FormData();
                formData.append("file", $("#xfXlsFile")[0].files[0]);
                // 清除file
                let obj = document.getElementById('xfXlsFile');
                obj.value = '';

                $.ajax({
                    type: "post",
                    dataType: "json",
                    processData: false,
                    contentType: false,
                    url: Vue.ctUrl + "vip/import",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: formData,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('导入成功');
                            $(_this.$refs.xfList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            // layer.msg(data.response.error_msg);
                            layer.open({
                                type: 1,
                                title: '导入失败，数据错误，请修正数据后重新导入！',
                                skin: 'import-err',
                                area: ['700px', ''],
                                content: data.response.error_msg,
                                btn: ['忽略错误继续导入', '重新导入'],
                                cancel: function() {
                                    layer.closeAll();
                                },
                                yes: function() {
                                    // 忽略错误继续导入
                                    let cindex = layer.open({
                                        type: 1,
                                        title: '温馨提示',
                                        skin: 'import-err',
                                        area: ['550px', ''],
                                        content: '<span style="color: red;">如果您选择继续导入，系统将跳过并记录所有格式不正确的手机号码和生日日期至会员的备注栏中，而不会对相应的原字段进行任何更新。请确认是否忽略这些错误并继续执行导入操作？</span>',
                                        btn: ['确认', '取消'],
                                        cancel: function () {
                                            // 重新导入
                                            layer.close(cindex);
                                        },
                                        yes: function () {
                                            $.ajax({
                                                type: "post",
                                                dataType: "json",
                                                processData: false,
                                                contentType: false,
                                                url: Vue.ctUrl + "vip/import?ignore_error=1",
                                                crossDomain: true,
                                                xhrFields: {
                                                    withCredentials: true
                                                },
                                                data: formData,
                                                success: function(res) {
                                                    if(res.response.result_code == "true") {
                                                        layer.closeAll();
                                                        layer.msg('导入成功');
                                                        $(_this.$refs.xfList).bootstrapTable('refresh');
                                                    } else {
                                                        Vue.timeoutfun(res.response.result_status, _this);
                                                        layer.msg(res.response.error_msg);
                                                    }
                                                },
                                                error: function(err) {
                                                    layer.msg("出错啦");
                                                }
                                            });
                                        }
                                    });
                                }
                            })
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 点击短信群发
            xfSendMsgs: function() {
                let _this = this;

                // 清空
                _this.xf_temp_id = '';
                _this.xf_temp_params = [];
                $(_this.$refs.xf_msg_con).html('请选择消息模板');
                _this.xf_sel_date = '';

                // 短信模板
                _this.initXfMsgTemps();

                _this.editSendMsgs('1');
            },
            // 短信模板
            initXfMsgTemps: function() {
                let _this = this;
                $(_this.$refs.xf_msg_temps).bootstrapTable('destroy');
                $(_this.$refs.xf_msg_temps).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getMsgTemps(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        radio: true,
                        title: '单选',
                        valign: "middle"
                    }, {
                        field: "index",
                        title: "行号",
                        width: "10%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "content",
                        title: "消息模板",
                        valign: "middle"
                    }],
                    clickToSelect: true
                });
            },
            getMsgTemps: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": 0,
                            "page_size": 0,
                            "shop_id": $(_this.$refs.xfShop).val()
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Vip/getMassSmsTemplates",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.sms_templates.length,
                                rows: data.response.result.sms_templates
                            });
                            _this.xf_shop_amount = data.response.result.shop_account_balance;
                            _this.xf_msg_amount = data.response.result.sms_price;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 打开短信模板
            openMsgTemps: function() {
                let _this = this;
                layer.confirm('', {
                    skin: 'add_goods-alert',
                    type: 1,
                    btn: ['确定', '取消'],
                    title: ['选择消息模板', true],
                    area: ['660px', '500px'],
                    content: $(_this.$refs.xf_msg_template),
                    offset: '100px'
                }, function() {
                    $.map($(_this.$refs.xf_msg_temps).bootstrapTable('getSelections'), function(row) {
                        _this.xf_temp_id = row.id;
                        _this.xf_temp_params = row.content.match(/(param_\d)/g);
                        $(_this.$refs.xf_msg_con).html(row.content.replace(/\{(param_\d)\}/g, '<input type="text" class="xf-temp-inp" ref="xf_temp_inp">'));
                        layer.close(layer.index);
                        // console.log(row.content.replace(/\{(param_\d)\}/g, '<input type="text">'));
                        // console.log(row.content.match(/(param_\d)/g));
                    });
                });
            },
            // 打开短信群发历史记录
            openXfHistory: function() {
                let _this = this;
                $(_this.$refs.xf_history_list).bootstrapTable('destroy');
                $(_this.$refs.xf_history_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getXfHistory(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "user_info",
                        title: "收件人",
                        width: "10%",
                        valign: "middle",
                        events: {
                            'click .list': function(e, value, row) {
                                _this.initXfSendObj(row.id);
                                layer.open({
                                    type: 1,
                                    title: '发送详情',
                                    skin: 'layui-layer-rim', // 加上边框
                                    area: ['660px', '380px'], // 宽高
                                    content: $(_this.$refs.xf_send_obj)
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-orange list">'+ value +'...</span>';
                        }
                    }, {
                        field: "send_time",
                        title: "发送时间",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "template_content",
                        title: "发送内容",
                        width: "13%",
                        valign: "middle"
                    }, {
                        field: "status_name",
                        title: "状态",
                        width: "6%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            if(row.status == '2') {
                                return value + '<br />成功'+ row.send_sms_success +'条，失败'+ row.send_sms_fail +'条';
                            } else {
                                return value;
                            }
                        }
                    }, {
                        title: "操作",
                        width: "8%",
                        valign: "middle",
                        events: {
                            'click .edit': function(e, value, row) {
                                _this.xf_temp_id = row.template_id;
                                _this.xf_temp_params = [];
                                let arr = [];
                                for(let key in row.template_params) {
                                    _this.xf_temp_params.push(key);
                                    arr.push(row.template_params[key]);
                                }
                                $(_this.$refs.xf_msg_con).html(row.template_content_ori.replace(/\{(param_\d)\}/g, '<input type="text" class="xf-temp-inp">'));
                                $.each($('.xf-temp-inp'), function(k, v) {
                                    $(v).val(arr[k]);
                                });
                                _this.xf_sel_date = row.send_time;

                                // 短信模板
                                _this.initXfMsgTemps();
                                _this.editSendMsgs('2', row.id, row.shop_id, row.template_content_ori);
                            },
                            'click .del': function(e, value, row) {
                                layer.confirm('删除后所选发送信息均不能恢复，确定删除？', {
                                    btn: ['确定', '取消']
                                }, function() {
                                    _this.delXfSend(row.id, row.shop_id);
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            if(row.status == '-1') {
                                return '<span class="text-orange edit">修改</span>&nbsp;&nbsp;&nbsp;<span class="text-orange del">删除</span>'
                            } else if(row.status == '1') {
                                return '';
                            } else if(row.status == '2') {
                                return '<span class="text-orange del">删除</span>'
                            }
                        }
                    }]
                });
            },
            getXfHistory: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "shop_id": $(_this.$refs.xfShop).val()
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Vip/getMassSmsList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $('.member-xf-history').show();
                            $('.member-xf-list').hide();
                            if(pageNumber == '1') {
                                _this.xf_history_count = data.response.result.count;
                            }
                            params.success({
                                total: _this.xf_history_count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 短信发送对象
            initXfSendObj: function(id) {
                let _this = this;
                $(_this.$refs.xf_send_list).bootstrapTable('destroy');
                $(_this.$refs.xf_send_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getXfSendObj(params, id);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "vip_name",
                        title: "会员姓名",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "vip_mobile",
                        title: "收件人",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "send_time",
                        title: "发送时间",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "status_name",
                        title: "状态",
                        width: "6%",
                        valign: "middle"
                    }]
                });
            },
            getXfSendObj: function(params, id) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Vip/getMassSmsUserInfo",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(pageNumber == '1') {
                                _this.xf_send_count = data.response.result.count;
                            }
                            params.success({
                                total: _this.xf_send_count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            // 新增、修改群发短信
            editSendMsgs: function(type, id, shop_id, template_content_ori) {
                let _this = this;
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Vip/checkMassSms",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {},
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.closeAll();
                            layer.confirm('', {
                                skin: 'add_goods-alert',
                                type: 1,
                                btn: ['确定', '取消'],
                                title: ['会员短信群发', true],
                                area: ['660px', ''],
                                content: $(_this.$refs.xf_msg_edit),
                                offset: '100px'
                            }, function() {
                                if(_this.xf_temp_id == '') {
                                    layer.msg('请选择消息模板');
                                } else if(_this.xf_sel_date == '') {
                                    layer.msg('请选择日期');
                                } else {
                                    if(type == '1') {
                                        // 新增
                                        let template_params = {};
                                        let con_sign = true;
                                        $.each($('.xf-temp-inp'), function(k, v) {
                                            if($.trim($(v).val()) == '') {
                                                con_sign = false;
                                                return false;
                                            }
                                            template_params[_this.xf_temp_params[k]] = $(v).val();
                                        });
                                        if(!con_sign) {
                                            layer.msg('请把发送内容填写完整');
                                            return false;
                                        }

                                        let vip_card = '',
                                            mobile = '',
                                            nickname = '';
                                        if(_this.xfSearch_field == 'kh_id') {
                                            vip_card = _this.xfSearch_info;
                                        } else if(_this.xfSearch_field == 'phone_numb') {
                                            mobile = _this.xfSearch_info;
                                        } else if(_this.xfSearch_field == 'wechat_name') {
                                            nickname = _this.xfSearch_info;
                                        }
                                        let datas = {
                                            "header": Vue.request_header,
                                            "request": {
                                                "version": Vue.version,
                                                "param": {
                                                    "birthday_start_time": _this.xfBirStartTime,
                                                    "birthday_end_time": _this.xfBirEndTime,
                                                    "start_time": _this.xfStartTime,
                                                    "end_time": _this.xfEndTime,
                                                    "shop_id": $(_this.$refs.xfShop).val(),
                                                    "shop_name": $(_this.$refs.xfShop).find("option:selected").text(),
                                                    "vip_card": vip_card,
                                                    "mobile": mobile,
                                                    "nickname": nickname,
                                                    "template_id": _this.xf_temp_id,
                                                    "template_params": template_params,
                                                    "send_time": _this.xf_sel_date
                                                }
                                            },
                                            "comment": ""
                                        };
                                        let datas2 = JSON.stringify(datas);
                                        $.ajax({
                                            type: "post",
                                            dataType: "json",
                                            url: Vue.ctUrl + "Vip/addMassSms",
                                            crossDomain: true,
                                            xhrFields: {
                                                withCredentials: true
                                            },
                                            data: datas2,
                                            success: function(data) {
                                                if(data.response.result_code == "true") {
                                                    layer.closeAll();
                                                    layer.msg(data.response.error_msg);
                                                    $(_this.$refs.xfList).bootstrapTable('refresh');
                                                } else {
                                                    Vue.timeoutfun(data.response.result_status, _this);
                                                    layer.msg(data.response.error_msg);
                                                }
                                            },
                                            error: function(err) {
                                                layer.msg("出错啦");
                                            }
                                        });
                                    } else if(type == '2') {
                                        // 修改
                                        // let template_content = template_content_ori;
                                        // $.each($('.xf-temp-inp'), function(k, v) {
                                        //     template_content = template_content.replace(/\{(param_\d)\}/, $(v).val());
                                        // });
                                        // console.log(template_content);
                                        let template_params = {};
                                        $.each($('.xf-temp-inp'), function(k, v) {
                                            template_params[_this.xf_temp_params[k]] = $(v).val();
                                        });
                                        let datas = {
                                            "header": Vue.request_header,
                                            "request": {
                                                "version": Vue.version,
                                                "param": {
                                                    "id": id,
                                                    "shop_id": shop_id,
                                                    "template_id": _this.xf_temp_id,
                                                    "template_params": template_params,
                                                    "send_time": _this.xf_sel_date
                                                }
                                            },
                                            "comment": ""
                                        };
                                        let datas2 = JSON.stringify(datas);
                                        $.ajax({
                                            type: "post",
                                            dataType: "json",
                                            url: Vue.ctUrl + "Vip/editMassSms",
                                            crossDomain: true,
                                            xhrFields: {
                                                withCredentials: true
                                            },
                                            data: datas2,
                                            success: function(data) {
                                                if(data.response.result_code == "true") {
                                                    layer.closeAll();
                                                    layer.msg(data.response.error_msg);
                                                    $(_this.$refs.xf_history_list).bootstrapTable('refresh');
                                                } else {
                                                    Vue.timeoutfun(data.response.result_status, _this);
                                                    layer.msg(data.response.error_msg);
                                                }
                                            },
                                            error: function(err) {
                                                layer.msg("出错啦");
                                            }
                                        });
                                    }
                                }
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 删除群发短信
            delXfSend: function(id, shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Vip/delMassSms",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('删除成功');
                            $(_this.$refs.xf_history_list).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    .member-xf-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 1700px;
                max-width: 2000px;
                // table-layout: fixed;
                word-break: break-all;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
        .range-txt {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0;
            .item {
                font-size: 14px;
                span {
                    color: #5e5e5e;
                }
                .el-input {
                    margin: 0 30px 0 10px;
                    width: 130px;
                }
            }
        }
        .pull-right {
            button {
                margin-left: 10px;
            }
            input {
                display: none;
            }
        }
        .check-sum {
            margin-top: -30px;
            margin-left: 20px;
            color: #409EFF;
            cursor: pointer;
        }
        .custom-icon {
            font-size: 20px;
        }
    }
    .member-xf-detail {
        display: none;
        .member-xf-dcon {
            overflow: hidden;
        }
        .col-md-5, .col-md-10 {
            padding-left: 0;
            font-size: 14px;
            >label {
                height: 40px;
                line-height: 40px;
                padding: 0;
                margin-bottom: 0px;
            }
            >span {
                min-height: 40px;
                padding-left: 0;
                margin: 9px 0 0;
                line-height: 23px;
            }
        }
        .member-xf-dbtn {
            margin: 30px 0 0;
        }
    }
    .xf-msg-edit {
        display: none;
        width: 80%;
        padding: 0;
        margin: 0 auto 20px;
        label {
            padding: 0;
            line-height: 32px;
            color: #5e5e5e;
            font-size: 14px;
            text-align: right;
            font-weight: normal;
        }
        .row {
            margin: 0 0 20px;
        }
        .xf-msg-tit {
            margin: 0 0 20px;
            line-height: 30px;
            font-size: 14px;
            text-align: center;
            em {
                color: #FB1026;
                font-style: normal;
            }
        }
        .xf-msg-obj {
            border: 1px solid #ccc;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
            textarea {
                resize: none;
                outline: none;
                width: 100%;
                height: 40px;
                border: none;
            }
            p {
                padding: 0 12px 0 0;
                text-align: right;
                em {
                    color: #FB1026;
                    font-style: normal;
                }
            }
        }
        .xf-msg-con {
            padding: 8px 12px;
            border: 1px solid #ccc;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
            input {
                width: 100px;
                padding: 0 8px;
                border-bottom: 1px solid #CCC;
            }
        }
        .xf-msg-time {
            p {
                margin: 10px 0 0;
                color: #FB1026;
            }
        }
    }
    .xf-msg-template {
        display: none;
        width: 90%;
        margin: 0 auto;
    }
    .member-xf-history {
        display: none;
        table {
            // table-layout: fixed;
            word-wrap: break-word;
        }
    }
    .xf-send-obj {
        display: none;
        width: 90%;
        margin: 0 auto;
    }
    /* 排行榜 */
    .member-xf-ranking {
        display: none;
        .member-xf-rk-tit li {
            float: left;
            margin: 60px 60px 0 0;
            color: #333;
            font-size: 16px;
            cursor: pointer;
        }
        .member-xf-rk-tit .member-xf-tit-sel {
            color: #31a5ff;
        }
        .member-xf-rk-con div {
            display: none;
        }
        .member-xf-rk-con .member-xf-con-sel {
            display: block;
        }
        .member-xf-rk-con h3 {
            margin: 30px 0;
            color: #333;
            font-size: 20px;
            text-align: center;
        }
        .member-xf-rk-con li {
            margin: 0 0 20px;
            line-height: 30px;
        }
        .member-xf-rk-con li em {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            float: left;
            font-size: 14px;
            font-style: normal;
        }
        .member-xf-rk-con li p {
            float: left;
            width: 20%;
            height: 30px;
            padding: 0 15px;
            margin: 0;
            color: #FFF;
            font-size: 14px;
            background: #31a5ff;
            background-size: 30%;
            border-radius: 20px;
        }
        .member-xf-rk-con div>p {
            display: none;
            text-align: center;
        }
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>